export default __webpack_public_path__ + "static/media/competition-details.eb832f63.md";